import { defineStore } from 'pinia'

import type { TutorBillingReturnStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useTutorBillingReturnStore = defineStore('tutor-billing-return', {
  state: (): TutorBillingReturnStore => ({
    returnPath: null,
  }),
  actions,
  getters,
})
